const Footer = () => {
  return (
    <div className="flex items-center justify-between px-[88px] py-6">
      {/* Footer content */}
    </div>
  );
};

export default Footer;
